import React from 'react';
import PropTypes from 'prop-types';

const NavigationButton = ({active = false, alt, icon, onClick}) => (
    <div style={{
        ...styles.flexCentered,
        ...styles.icon,
        backgroundColor: active ? '#006980' : 'transparent',
    }} onClick={onClick}>
        <img src={icon.replace('.png', active ? 'Active.png' : '.png')} alt={alt}/>
    </div>
);

NavigationButton.propTypes = {
    active: PropTypes.bool,
    alt: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func,
}

const styles = {
    flexCentered: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {
        cursor: 'pointer',
        width: '156px',
    },
}

export default NavigationButton;
